import { ExternalLink, Plus } from 'assets/icons';
import { cardIconButtonClass } from 'components/card/PanelCard';
import IconTooltip from 'components/iconTooltip/IconTooltip';
import useHomeText from 'hooks/useHomeText';

// The head of « Planning »: its title, then the buttons that open the
// planning and add an appointment.
const AgendaHeader = ({ onOpenPlanning, onAdd }) => {
  const { text } = useHomeText();
  const buttons = [
    { label: text('agenda.open'), icon: ExternalLink, onClick: onOpenPlanning },
    { label: text('agenda.add'), icon: Plus, onClick: onAdd },
  ];
  return (
    <div className="flex items-center justify-between">
      <p className="text-base font-semibold text-gray-900">{text('agenda.title')}</p>
      <div className="flex gap-2">
        {buttons.map(({ label, icon: Icon, onClick }) => (
          <IconTooltip key={label} label={label}>
            <button
              type="button"
              aria-label={label}
              onClick={onClick}
              className={`${cardIconButtonClass} text-gray-700`}
            >
              <Icon wh={16} color="currentColor" />
            </button>
          </IconTooltip>
        ))}
      </div>
    </div>
  );
};

export default AgendaHeader;
